import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  FButton,
  FCard,
  FGrid,
  FGridItem,
  FInputText,
  FItem,
  FTypo,
} from "ferrum-design-system";
import { ReactComponent as IconGoBack } from "../../../../../assets/img/icon-back-white.svg";
// import { ReactComponent as IconNetworkCFrm } from "../../../../../assets/img/icon-network-cfrm.svg";
// import { ReactComponent as IconNetworkBsc } from "../../../../../assets/img/icon-network-bnb.svg";
import { DialogTransitionStatus } from "./DialogTransitionStatus";
import { Web3Helper } from "./../../../../../container-components/web3Client/web3Helper";
import { CrucibleClient } from "./../../../../../container-components/web3Client/crucibleClient";
import { ApprovableButtonWrapper } from "./../../../../../container-components/web3Client/approvalButtonWrapper";
import { useHistory, useLocation, useParams } from "react-router";
// import { useWeb3React } from "@web3-react/core";
import {
  CRUCIBLE_CONTRACTS_V_0_1,
  Crucible_Farm_Address_Details,
  STEP_FLOW_IDS,
  getBaseTokenName,
  getCrucibleTokenName,
} from "./../../../common/utils";
import { RootState } from "../../../../../redux/rootReducer";
import { useDispatch, useSelector } from "react-redux";
import { BigUtils } from "./../../../../../container-components/web3Client/types";
import * as CrucibleActions from "../../../redux/CrucibleActions";
import * as SFSH_API from "../../../../../_apis/StepFlowStepHistory";
import {
  getCrucibleDetail,
  getLatestStepToRender,
  getObjectReadableFarmName,
  //  getNextStepFlowStepId
} from "../../../common/Helper";
import { ClipLoader } from "react-spinners";
import { useWalletConnector, WalletConnector } from "foundry";
import { ConnectWalletDialogMultiSwap } from "../../../../../utils/connect-wallet/ConnectWalletDialogMultiSwap";
import {
  changeExponentToPoints,
  getErrorMessage,
  TruncateWithoutRounding,
} from "../../../../../utils/global.utils";
import Big from "big.js";
import { createGlobalStyle, ThemeProvider } from "styled-components";
import { Toaster, toast } from "react-hot-toast";

export const UnWrap = () => {
  const location: any = useLocation();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  let { farm } = useParams<{ farm?: string }>();
  farm = farm === "cFRM-ARBITRUM" ? "cTestFrm" : farm;
  const dispatch = useDispatch();
  const [transitionStatusDialog, setTransitionStatusDialog] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isProcessed, setIsProcessed] = useState(false);
  const crucible = useSelector(
    (state: RootState) => state.crucible.selectedCrucible
  );
  const userCrucibleData = useSelector(
    (state: RootState) => state.crucible.userCrucibleDetails
  );
  const [transactionId, setTransactionId] = useState("");
  const { isConnected, walletAddress, web3Sdk } = useWalletConnector();
  const [amount, setAmount] = useState(0);
  const tokenPrices = useSelector(
    (state: RootState) => state.crucible.tokenPrices
  );
  const { stepFlowStepHistory, currentStep, currentStepIndex } = useSelector(
    (state: RootState) => state.crucible
  );
  const { meV2, tokenV2 } = useSelector(
    (state: RootState) => state.walletAuthenticator
  );
  const { activeTranslation } = useSelector((state: RootState) => state.phrase);
  const { theme, content } = useSelector((state: RootState) => state.config);

  const getStepCompleted = async (renderNeeded: any) => {
    setIsLoading(true);
    try {
      let updatedCurrentStep = { ...currentStep, status: "completed" };
      let updHistory = stepFlowStepHistory.map((obj, index) =>
        index === currentStepIndex ? { ...obj, status: "completed" } : obj
      );
      let data = { status: "completed" };

      dispatch(
        CrucibleActions.updateCurrentStep({
          currentStep: updatedCurrentStep,
          currentStepIndex: currentStepIndex,
        })
      );
      dispatch(
        CrucibleActions.updateStepFlowStepHistory({
          stepFlowStepHistory: updHistory,
        })
      );

      // let updateResponse: any =
      await SFSH_API.updateStepsFlowStepsHistoryStatusByAssociatedUserIdByStepsFlowStepsHistoryId(
        currentStep._id,
        data,
        tokenV2
      );
      // console.log('updateStepsFlowStepsHistoryStatusByAssociatedUserIdByStepsFlowStepsHistoryId', 'unwrap card 69')
      // updateResponse = updateResponse?.data?.body?.stepsFlowStepHistory;
      getLatestStepToRender(
        location.state,
        tokenV2,
        currentStep,
        currentStepIndex,
        stepFlowStepHistory,
        dispatch,
        history,
        farm,
        setIsLoading,
        renderNeeded
      );
    } catch (e: any) {
      getErrorMessage(e, activeTranslation);
    }
  };

  const onUnWrapClick = async (
    currency: string,
    crucibleAddress: string,
    amount: string,
    isPublic: boolean,
    network: string,
    userAddress: string
  ) => {
    if (web3Sdk) {
      setTransitionStatusDialog(true);
      setIsProcessing(true);
      const web3Helper = new Web3Helper(web3Sdk as any);
      const client = new CrucibleClient(web3Helper);
      console.log("unwrap =========");
      try {
        const response = await client.unwrapCrucible(
          dispatch,
          currency,
          crucibleAddress,
          amount,
          isPublic,
          network,
          userAddress,
          setTransitionStatusDialog
        );
        if (response) {
          let transactionId = response.transactionHash;
          setTransactionId(transactionId);
          setIsProcessing(false);
          //setIsSubmitted(true)
          setIsProcessed(true);
          getStepCompleted(false);
          getCrucibleDetail(
            Crucible_Farm_Address_Details[farm!],
            web3Sdk,
            walletAddress,
            dispatch,
            setIsLoading
          );
        }
      } catch (err: any) {
        console.log(err.message);
        toast.error(err.message);
        setTransitionStatusDialog(false);
      }
    }
  };

  const onContinueToNextStepClick = () => {
    setIsLoading(true);
    if (currentStep.status === "pending") {
      location.state.id = currentStep.stepFlow;
      let splitted = currentStep.stepFlowStep.name.split("-");
      location.state.name = splitted[0].trim() + " - " + splitted[1].trim();
      getLatestStepToRender(
        location.state,
        tokenV2,
        currentStep,
        currentStepIndex,
        stepFlowStepHistory,
        dispatch,
        history,
        farm,
        setIsLoading
      );
    } else {
      let nextStepInfo: any;
      if (farm === "cFRM-BNB" || farm === "cFRMx-BNB") {
        nextStepInfo =
          STEP_FLOW_IDS[`${getObjectReadableFarmName(farm)}`]
            .generalAddLiquidity;
      } else if (farm === "cFRM" || farm === "cFRMx" || farm === "cTestFrm") {
        nextStepInfo =
          STEP_FLOW_IDS[`${getObjectReadableFarmName(farm)}`].unwrap;
      }
      location.state.id = nextStepInfo.id;
      location.state.stepFlowName = nextStepInfo.name;
      getLatestStepToRender(
        location.state,
        tokenV2,
        currentStep,
        currentStepIndex + 1,
        stepFlowStepHistory,
        dispatch,
        history,
        farm,
        setIsLoading
      );
    }
  };

  const getDisabledCheck = () => {
    return (
      Number(userCrucibleData[farm!]?.balance) === 0 ||
      Number(amount) === 0 ||
      Number(userCrucibleData[farm!]?.balance) < Number(amount)
    );
  };

  const GlobalStyles = createGlobalStyle`
.crucible-farm-dashboard-card, .farm-card {
  background-image: url(${theme?.cards?.crucibleDashboardCard}) !important;
  .btn-wrap {
    .f-btn-primary {
      background: ${theme?.colors?.primary} !important;
      border: 1px solid ${theme?.colors?.primary} !important;
    }
  }
  .f-input-group{
     .f-input-wrap {
      background: ${theme?.colors?.background} !important;
      outline: 1px solid${theme?.colors?.primary} !important;
    }
  }
  .f-input-group { 
    .f-input-control {
      color: ${theme?.colors?.primaryLight} !important;
    }

  }
}
`;

  return (
    <>
      <ThemeProvider theme={theme}>
        <Toaster />
        {isLoading ? (
          // <FCard>
          <div className="loading-spinner">
            <FItem align={"center"}>
              <ClipLoader
                color={theme?.colors?.primary}
                loading={true}
                size={150}
              />
            </FItem>
          </div>
        ) : (
          // </FCard>
          <div className={"crucible-farm-dashboard-card farm-card"}>
            <div className="card-title f-mb-2">
              <FItem display={"flex"} alignY="center">
                <Link
                  to="/dashboard/crucible"
                  className="btn-back custom-mr-14"
                >
                  <IconGoBack />
                </Link>
                <FTypo
                  size={20}
                  weight={700}
                  color={theme?.colors?.primaryLight}
                >
                  {location?.state?.json[0]?.unwrap?.header || (
                    <>
                      {content?.unwrap?.header}
                      <span className="f-ml-1">
                        {farm?.includes("cFRMx") ? "cFRMx" : "cFRM"}{" "}
                        {farm?.includes("BNB") ? "/ BNB LP" : ""}
                      </span>
                    </>
                  )}
                </FTypo>
              </FItem>
            </div>
            {theme?.type === "ferrum" ? (
              <FGrid>
                <FGridItem size={[6, 6, 6]}>
                  <FItem
                    bgColor={theme?.colors?.background}
                    className={"f-p-2 "}
                  >
                    <FTypo
                      size={18}
                      color={theme?.colors?.backgroundLight}
                      className="f-mb-1 unwrap-card-price"
                    >
                      {getBaseTokenName(farm)} Price (USD)
                    </FTypo>
                    <FTypo
                      size={30}
                      weight={500}
                      color={theme?.colors?.primaryLight}
                    >
                      ${tokenPrices[getBaseTokenName(farm)!] || 0}
                    </FTypo>
                  </FItem>
                </FGridItem>
                <FGridItem size={[6, 6, 6]}>
                  <FItem
                    bgColor={theme?.colors?.background}
                    className={"f-p-2 "}
                  >
                    <FTypo
                      size={18}
                      color={theme?.colors?.backgroundLight}
                      className="f-mb-1 unwrap-card-price"
                    >
                      {getCrucibleTokenName(farm)} Price (USD)
                    </FTypo>
                    <FTypo
                      size={30}
                      weight={500}
                      color={theme?.colors?.primaryLight}
                    >
                      ${tokenPrices[getCrucibleTokenName(farm)!] || 0}
                    </FTypo>
                  </FItem>
                </FGridItem>
              </FGrid>
            ) : null}
            <div className="f-mt-1 f-mb-2 align_start justify_start d-flex">
              <div className="custom-mr-16 w-100">
                <div>
                  <FTypo
                    size={18}
                    weight={700}
                    color={theme?.colors?.primaryLight}
                  >
                    Deposit
                  </FTypo>
                  <FInputText
                    className={"f-mt-1 w-100 f-mb--7"}
                    inputSize="input-lg"
                    type={"text"}
                    placeholder="0"
                    value={amount === 0 ? "" : amount}
                    onChange={(e: any) => setAmount(e.target.value)}
                    postfix={
                      <FTypo
                        className={"f-pr-1"}
                        color={theme?.colors?.primaryLight}
                      >
                        <span
                          onClick={() =>
                            setAmount(userCrucibleData[farm!]?.balance || "0")
                          }
                        >
                          Max
                        </span>
                      </FTypo>
                    }
                  />
                  <FTypo
                    size={12}
                    weight={500}
                    color={theme?.colors?.backgroundLight}
                  >
                    You have{" "}
                    {TruncateWithoutRounding(
                      userCrucibleData[farm!]?.balance || "0",
                      3
                    )}{" "}
                    available in Token {userCrucibleData[farm!]?.symbol}.
                  </FTypo>
                </div>
              </div>
              <div className={"w-100"}>
                <FTypo
                  size={18}
                  weight={700}
                  color={theme?.colors?.primaryLight}
                >
                  Receive
                </FTypo>
                <FInputText
                  inputSize="input-lg"
                  className={"f-mt-1 w-100 f-mb--7"}
                  type={"text"}
                  placeholder="0"
                  disabled={true}
                  value={changeExponentToPoints(
                    Big(amount || "0")
                      .minus(
                        Big(amount || "0").times(
                          crucible[farm!]?.feeOnWithdrawRate || "0"
                        )
                      )
                      .toString()
                  )}
                  postfix={
                    <FTypo
                      className={"f-pr-1"}
                      color={theme?.colors?.primaryLight}
                    >
                      {crucible[farm!]?.baseSymbol}
                    </FTypo>
                  }
                />
                <FTypo
                  size={12}
                  weight={500}
                  color={theme?.colors?.backgroundLight}
                >
                  Amount {crucible[farm!]?.baseSymbol} you will receive
                </FTypo>
              </div>
            </div>
            {meV2._id && isConnected ? (
              <ApprovableButtonWrapper
                View={(ownProps) => {
                  // onPropChange(ownProps);
                  return (
                    <div className="btn-wrap f-mt-2 f-mb-2">
                      <FButton
                        title={"UNWRAP"}
                        className={
                          "w-100 clr_new_black custom-font-size-16 font-700"
                        }
                        disabled={getDisabledCheck()}
                        onClick={onUnWrapClick(
                          crucible[farm!]?.baseCurrency,
                          crucible[farm!]?.currency || "",
                          amount.toString(),
                          true,
                          crucible[farm!]?.network,
                          walletAddress as string
                        )}
                      ></FButton>
                    </div>
                  );
                }}
                currency={crucible[farm!]?.currency}
                contractAddress={CRUCIBLE_CONTRACTS_V_0_1["BSC"].router}
                userAddress={walletAddress as string}
                amount={amount.toString()}
              />
            ) : (
              <WalletConnector
                WalletConnectView={FButton}
                WalletConnectModal={ConnectWalletDialogMultiSwap}
                WalletConnectViewProps={{
                  className: "btn-wrap f-mt-2 w-100 f-mb-2",
                }}
              />
            )}
            <DialogTransitionStatus
              transitionStatusDialog={transitionStatusDialog}
              setTransitionStatusDialog={setTransitionStatusDialog}
              isProcessing={isProcessing}
              setIsProcessing={setIsProcessing}
              setapprovedDone={false}
              transactionId={transactionId}
              isSubmitted={false}
              isProcessed={isProcessed}
              crucible={crucible[farm!]}
              onContinueToNextStepClick={() => onContinueToNextStepClick()}
            />
          </div>
          // <FCard variant={"secondary"} className="card-deposit  card-shadow">
          //   <div className="card-title">
          //     <FItem display={"flex"} alignY="center">
          //       <Link to={`/dashboard/crucible/${farm}/manage`} className="btn-back">
          //         <IconGoBack />
          //       </Link>
          //       <FTypo size={24} weight={700}>
          //         Unwrap Crucible Token 1111111
          //       </FTypo>
          //     </FItem>
          //   </div>
          //   <FGrid>
          //     <FGridItem size={[6, 6, 6]}>
          //       <FItem bgColor="#1C2229" className={"f-p-2"}>
          //         <FTypo size={20} className="f-mb-1">
          //           {getBaseTokenName(farm)} Price (USD)
          //         </FTypo>
          //         <FTypo size={30} weight={500}>
          //           ${tokenPrices[getBaseTokenName(farm)!]}
          //         </FTypo>
          //       </FItem>
          //     </FGridItem>
          //     <FGridItem size={[6, 6, 6]}>
          //       <FItem bgColor="#1C2229" className={"f-p-2"}>
          //         <FTypo size={20} className="f-mb-1">
          //           {getCrucibleTokenName(farm)} Price (USD)
          //         </FTypo>
          //         <FTypo size={30} weight={500}>
          //           ${tokenPrices[getCrucibleTokenName(farm)!]}
          //         </FTypo>
          //       </FItem>
          //     </FGridItem>
          //   </FGrid>
          //   <FInputText
          //     className={"f-mt-1"}
          //     inputSize="input-lg"
          //     type={"text"}
          //     placeholder="0"
          //     value={amount === 0 ? "" : amount}
          //     onChange={(e: any) => setAmount(e.target.value)}
          //     postfix={
          //       <FTypo color="#DAB46E" className={"f-pr-1"}>
          //         <span onClick={() => setAmount(userCrucibleData[farm!]?.balance || "0")}>Max</span>
          //       </FTypo>
          //     }
          //   />
          //   <FTypo color="#DAB46E" size={15} className={"f-mt-1 f-pl--5"}>
          //     You have {TruncateWithoutRounding(userCrucibleData[farm!]?.balance || "0", 3)} available in Token {userCrucibleData[farm!]?.symbol}.
          //   </FTypo>
          //   <FTypo size={15} className={"f-mt-2 f-pl--5"}>
          //     Amount you will receive
          //   </FTypo>
          //   <FInputText
          //     className={"f-mt-1"}
          //     inputSize="input-lg"
          //     type={"text"}
          //     placeholder="0"
          //     disabled={true}
          //     // value={changeExponentToPoints(Number(amount) - Number(amount) * (Number(BigUtils.safeParse(crucible[farm!]?.feeOnWithdrawRate || "0").times(100)) / 100))}
          //     value={changeExponentToPoints(Big(amount || "0").minus(Big(amount || "0").times(crucible[farm!]?.feeOnWithdrawRate || "0")).toString())}
          //     postfix={
          //       <FTypo color="#DAB46E" className={"f-pr-1 f-mt-1"}>
          //         {crucible[farm!]?.baseSymbol}
          //       </FTypo>
          //     }
          //   />
          //   {meV2._id && isConnected ? (
          //     <ApprovableButtonWrapper
          //       View={(ownProps) => (
          //         <div className="btn-wrap f-mt-2">
          //           <FButton
          //             title={"Unwrap"}
          //             className={"w-100"}
          //             disabled={getDisabledCheck()}
          // onClick={
          //   ownProps.isApprovalMode
          //     ? () => ownProps.onApproveClick()
          //     : () => onUnWrapClick(crucible[farm!]?.baseCurrency, crucible[farm!]?.currency || "", amount.toString(), true, crucible[farm!]?.network, walletAddress as string)
          // }
          //           ></FButton>
          //         </div>
          //       )}
          // currency={crucible[farm!]?.currency}
          // contractAddress={CRUCIBLE_CONTRACTS_V_0_1["BSC"].router}
          // userAddress={walletAddress as string}
          // amount={"0.0001"}
          //     />
          //   ) : (
          //     <WalletConnector
          //       WalletConnectView={FButton}
          //       WalletConnectModal={ConnectWalletDialog}
          //       WalletConnectViewProps={{ className: "btn-wrap f-mt-2 w-100" }}
          //     />
          //   )}

          // <DialogTransitionStatus
          //   transitionStatusDialog={transitionStatusDialog}
          //   setTransitionStatusDialog={setTransitionStatusDialog}
          //   isProcessing={isProcessing}
          //   setIsProcessing={setIsProcessing}
          //   setapprovedDone={false}
          //   transactionId={transactionId}
          //   isSubmitted={false}
          //   isProcessed={isProcessed}
          //   crucible={crucible[farm!]}
          //   onContinueToNextStepClick={() => onContinueToNextStepClick()}
          // />
          // </FCard>
        )}
        <GlobalStyles />
      </ThemeProvider>
    </>
  );
};
